import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as fromGroups from '../../reducers/groups.reducer';
import * as fromRoot from '@app/reducers';
import { Group } from '@app/shared/models/group';
import { User } from '@app/shared/models/user';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { GroupsActions } from '../../actions';
import { isEmail } from '@app/shared/helpers/validators';
import { Identity } from '@app/shared/models/identity';

@Component({
  selector: 'app-modal-attach-member',
  templateUrl: './modal-attach-member.component.html',
  styleUrls: ['./modal-attach-member.component.scss']
})
export class ModalAttachMemberComponent implements OnDestroy {

  attachMemberFromGroupPending$: Observable<boolean>;
  attachMemberFromGroupSuccess$: Observable<boolean>;
  attachMemberFromGroupError$: Observable<any>;

  group: Group;
  accountMembers: User[] = [];
  groupMembers: User[] = [];

  attachMemberForm: FormGroup;
  attachableMembers: User[];
  submitted = false;
  subscriptions: Subscription[] = [];
  selectedMember: User;
  teamId: string;
  identity: Identity;

  constructor(private store$: Store<fromRoot.State & fromGroups.State>, private fb: FormBuilder, public ref: DialogRef) {
    this.group = this.ref.data.group;
    this.teamId = this.ref.data.teamId;
    this.identity = this.ref.data.identity;
    this.accountMembers = this.ref.data.accountMembers;
    this.groupMembers = this.ref.data.groupMembers;

    this.buildAttachableMembers();

    this.attachMemberFromGroupPending$ = this.store$.select(fromGroups.getAttachMemberToGroupPending);
    this.attachMemberFromGroupSuccess$ = this.store$.select(fromGroups.getAttachMemberToGroupSuccess);
    this.attachMemberFromGroupError$ = this.store$.select(fromGroups.getAttachMemberToGroupError);

    this.initForm();
  }

  get f() { return this.attachMemberForm.controls; }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  initForm() {
    this.attachMemberForm = this.fb.group({
      member: ['', Validators.required],
    });
  }

  close() {
    this.ref.close();
  }

  buildAttachableMembers(): void {
    this.attachableMembers = this.accountMembers
    .filter(accountMember => !this.groupMembers.some(groupMember => groupMember.id === accountMember.id))
    .filter(member => member.id !== this.identity.id);
  }

  attachMemberToGroup(member: User, group: Group) {
    this.store$.dispatch(GroupsActions.AttachMemberToGroup({ teamId: this.teamId, member, groupId: group.id }));
    this.subscriptions.push(
      this.attachMemberFromGroupSuccess$.subscribe(res => {
        if (res) {
          this.store$.dispatch(GroupsActions.LoadGroupMembers({ teamId: this.teamId, id: this.group.id }));
          this.attachMemberForm.reset();
          this.selectedMember = null;
          this.close();
        }
      })
    );
  }

  addEmail(username: string) {
    if (isEmail(username)) {
      return { username };
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.attachMemberForm.valid) {
      this.attachMemberToGroup(this.attachMemberForm.value.member, this.group);
    }
  }
}
